// @ts-nocheck
import {getCubaREST} from "@cuba-platform/react";
import {UcoSignSignature} from "../../../cuba/entities/base/ucosign$Signature";
import {rootStore} from "../../store";


export const getSignature = async ({result}: { result: any }) => {
  if (!result || result.length <= 0) {
    return {
      signature: [],
      isDocumentSign: false,
      idDocument: ''
    };
  }

  try {
    const idDocument = result.ucoSignRegistrationId;

    const rawSignature = await getCubaREST()!.searchEntities<UcoSignSignature>(
      UcoSignSignature.NAME,
      {
        conditions: [
          {
            property: "signUser.id",
            operator: "=",
            value: rootStore?.userInfo?.id,
          },
          {
            property: "ucosignDocument.ucosignRegistration.id",
            operator: "=",
            value: idDocument,
          },
          // {
          //   property: "signDate",
          //   operator: "=",
          //   value: ""
          // }
        ],
      },
      {view: "ucoSignSignature.edit", sort: "signOrder"}
    );

    const signature = rawSignature as UcoSignSignature[];
    const isDocumentSign =
      rawSignature.filter((val) => val.signatureData == null).length === 0;

    return {
      signature,
      isDocumentSign,
      idDocument
    };
  } catch (error) {
    console.error("Error fetching signature data:", error);
    return {
      signature: [],
      isDocumentSign: false,
      idDocument: ''
    };
  }
};
